{
  "zh-TW": {
    "models": {
      "image": {
        "background": "用作背景?",
        "enabled": "已啟用?",
        "global": "全域?",
        "delete": "刪除",
        "start": "開始",
        "cancel": "取消",
        "processing": "處理中...",
        "error": "錯誤",
        "name": "名稱",
        "size": "檔案大小",
        "dropzone": "將圖片拖放到此處"
      }
    }
  }
}
